import axios from 'axios';
import React, { useEffect, useState, useMemo, useCallback } from 'react';
import '../CSS/ListOfRess.css';

// --- КОНФІГУРАЦІЯ ---
const API_WLAUNCH = 'https://api.wlaunch.net/v1';
const COMPANY_ID = '563101a4-a115-11ec-acf9-01bddefc6073';
const BRANCH_ID = '563176e9-a115-11ec-acf9-01bddefc6073';

// УВАГА: Токен тут більше не потрібен, він живе на сервері Vercel

// --- УТИЛІТИ ---
const capitalize = (str) => str ? str.charAt(0).toUpperCase() + str.slice(1) : '';

const secondsToHours = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const displayTime = minutes < 10 ? `${hours}:${minutes}0` : `${hours}:${minutes}`;
    return { displayTime };
};

const INITIAL_FORM = {
    name: '',
    lastName: '',
    phone: '',
    email: ''
};

export default function ListOfResource() {
    // 1. СТАТУСИ
    const [status, setStatus] = useState({
        loadingResources: true,
        loadingDetails: false,
        loadingSlots: false,
        error: null
    });

    // 2. ДАНІ
    const [resources, setResources] = useState([]);
    const [services, setServices] = useState([]);
    const [slotsData, setSlotsData] = useState(null);
    const [doctorDetails, setDoctorDetails] = useState(null);

    // 3. ВИБІР
    const [selection, setSelection] = useState({
        doctorId: null,
        serviceId: '',
        resourceId: '',
        serviceAmount: 0,
        serviceName: '',
        dateSlot: null,
        timeSlot: null
    });

    // 4. ФОРМА
    const [form, setForm] = useState(INITIAL_FORM);
    const [errors, setErrors] = useState({});

    // 5. БРОНЮВАННЯ
    const [booking, setBooking] = useState({
        otpSent: false,
        verificationCode: '',
        isCreated: false,
        isPaid: false,
        apptDate: null,
        apptNumber: null,
        apptPrice: '',
        apptServiceName: '',
        apptEmail: ''
    });

    // --- ОБЧИСЛЮВАНІ ЗНАЧЕННЯ (Логіка +2 години) ---
    const availableDates = useMemo(() => {
        if (!slotsData?.slots) return [];

        // Визначаємо поріг часу (Зараз + 2 години)
        const now = new Date();
        const bufferTime = new Date(now.getTime() + 2 * 60 * 60 * 1000);

        return slotsData.slots.flatMap(s => s.date_slots).map(ds => {
            const d = new Date(ds.date);

            // Фільтруємо слоти всередині дати
            const validSlots = ds.slots.filter(slot => {
                const h = Math.floor(slot.time.start_time / 3600);
                const m = Math.floor((slot.time.start_time % 3600) / 60);

                const [year, month, day] = ds.date.split('-').map(Number);
                const slotDate = new Date(year, month - 1, day, h, m, 0);

                return slotDate > bufferTime;
            });

            return {
                ...ds,
                slots: validSlots,
                dayName: capitalize(d.toLocaleDateString('uk-UA', { weekday: 'long' })),
                dayNum: d.getDate(),
                monthName: d.toLocaleDateString('uk-UA', { month: 'long' }),
                isDisabled: validSlots.length === 0
            };
        });
    }, [slotsData]);

    // --- ХЕЛПЕРИ ---
    const updateStatus = (key, value) => setStatus(prev => ({ ...prev, [key]: value }));

    const setError = (msg) => {
        console.error(msg);
        updateStatus('error', msg);
    };

    const resetFlow = useCallback((fullReset = false) => {
        setSelection(prev => ({
            ...prev,
            dateSlot: null,
            timeSlot: null,
            ...(fullReset ? { doctorId: null, serviceId: '' } : {})
        }));
        setForm(INITIAL_FORM);
        setBooking(prev => ({ ...prev, otpSent: false, verificationCode: '' }));
        if (fullReset) setSlotsData(null);
    }, []);

    // --- ЕФЕКТИ ---
    useEffect(() => {
        const loadResources = async () => {
            try {
                const { data } = await axios.get(`${API_WLAUNCH}/public/company/${COMPANY_ID}/branch/${BRANCH_ID}/resource?active=true`);
                setResources(data.content || []);
            } catch (err) {
                setError('Помилка завантаження спеціалістів: ' + err.message);
            } finally {
                updateStatus('loadingResources', false);
            }
        };
        loadResources();
    }, []);

    useEffect(() => {
        const query = new URLSearchParams(window.location.search);
        if (query.get('payment_status') === 'success') {
            const savedData = localStorage.getItem('temp_appointment_data');
            if (savedData) {
                const parsed = JSON.parse(savedData);
                setBooking(prev => ({
                    ...prev,
                    isPaid: true,
                    isCreated: true,
                    apptDate: parsed.date,
                    apptNumber: parsed.number
                }));
                window.history.replaceState({}, document.title, window.location.pathname);
                localStorage.removeItem('temp_appointment_data');
            }
        }
    }, []);

    // --- ОБРОБНИКИ ---
    const handleDoctorSelect = async (doctorId) => {
        resetFlow(true);
        setSelection(prev => ({ ...prev, doctorId }));
        updateStatus('loadingDetails', true);

        try {
            const start = new Date().toISOString().split('T')[0];
            const [detailsRes, servicesRes] = await Promise.all([
                axios.get(`${API_WLAUNCH}/public/company/${COMPANY_ID}/resource/${doctorId}`),
                axios.get(`${API_WLAUNCH}/public/company/${COMPANY_ID}/branch/${BRANCH_ID}/service`, {
                    params: {
                        active: true, size: 10, page: 0, parentId: 'root',
                        withPriceOn: `${start}T00:00:00.000Z`, resource: doctorId
                    }
                })
            ]);

            setDoctorDetails(detailsRes.data);
            setServices(servicesRes.data.content.map(s => ({ ...s, resourceId: doctorId })));
        } catch (err) {
            setError('Не вдалося завантажити деталі: ' + err.message);
        } finally {
            updateStatus('loadingDetails', false);
        }
    };

    const handleServiceSelect = async (resourceId, serviceId, amount, name) => {
        updateStatus('loadingSlots', true);
        setSelection(prev => ({
            ...prev, serviceId, resourceId, serviceAmount: amount, serviceName: name,
            dateSlot: null, timeSlot: null
        }));
        setForm(INITIAL_FORM);

        try {
            const start = new Date().toISOString().split('T')[0];
            const end = new Date(Date.now() + 14 * 24 * 60 * 60 * 1000).toISOString().split('T')[0];

            const { data } = await axios.get(`${API_WLAUNCH}/company/${COMPANY_ID}/branch/${BRANCH_ID}/slot/resource`, {
                params: {
                    start, end, slotSize: 3600, id: resourceId, serviceId,
                    startStrategy: 'DAY_START', minTimeStrategy: 'SCHEDULE',
                    alignStrategy: 'STRICT', includeAppointmentsTime: true
                }
            });
            setSlotsData(data);
        } catch (err) {
            setError('Немає вільного часу: ' + err.message);
        } finally {
            updateStatus('loadingSlots', false);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        let finalValue = value;

        if (name === 'phone') {
            const digits = value.replace(/\D/g, '');
            if (value === '') finalValue = '';
            else if (value === '+') finalValue = '+';
            else finalValue = '+' + digits;
        }

        setForm(prev => ({ ...prev, [name]: finalValue }));

        if (name === 'phone') {
            setErrors(prev => ({
                ...prev,
                phone: finalValue.length > 9 ? '' : 'Введіть коректний номер'
            }));
        }
        if (name === 'email') {
            setErrors(prev => ({
                ...prev,
                email: finalValue.includes('@') ? '' : "Обов'язково має містити @"
            }));
        }
    };

    const handleCreateAppointment = async () => {
        if (!form.name || !form.lastName || !form.phone || !form.email) return;
        if (errors.phone || errors.email) return;

        try {
            if (!booking.otpSent) {
                await axios.post(`${API_WLAUNCH}/company/${COMPANY_ID}/user/sign_in/phone/`, { phone: form.phone });
                setBooking(prev => ({ ...prev, otpSent: true }));
            } else {
                const verifyRes = await axios.post(`${API_WLAUNCH}/user/sign_in/phone/verify/.`, {
                    phone: form.phone,
                    code: booking.verificationCode
                });

                const accessToken = verifyRes.data.access_token;

                const h = Math.floor(selection.timeSlot.start_time / 3600);
                const m = Math.floor((selection.timeSlot.start_time % 3600) / 60);
                const isoString = new Date(`${selection.dateSlot.date}T${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:00`).toISOString();

                const appointmentPayload = {
                    appointment: {
                        company_id: COMPANY_ID,
                        branch_id: BRANCH_ID,
                        source: "WIDGET",
                        client: {
                            first_name: form.name, last_name: form.lastName,
                            phone: form.phone, email: form.email, extra_fields: {}
                        },
                        start_time: isoString,
                        extra_fields: {},
                        service_resource_settings: [{
                            service: selection.serviceId, resources: [selection.resourceId], ordinal: 1
                        }]
                    }
                };

                const { data } = await axios.post(`${API_WLAUNCH}/client/appointment`, appointmentPayload, {
                    headers: { 'Authorization': 'Bearer ' + accessToken, 'Content-Type': 'application/json' }
                });

                setBooking(prev => ({
                    ...prev,
                    isCreated: true,
                    apptDate: new Date(data.start_time).toLocaleString(),
                    apptNumber: data.number,
                    apptServiceName: data.services[0].name,
                    apptPrice: data.price,
                    apptEmail: data.client.email
                }));

                setSelection(prev => ({ ...prev, dateSlot: null, timeSlot: null }));
                setForm(INITIAL_FORM);
            }
        } catch (err) {
            setError('Помилка бронювання: ' + (err.response?.data?.message || err.message));
        }
    };

    // --- ОНОВЛЕНИЙ МЕТОД ОПЛАТИ (ЧЕРЕЗ VERCEL FUNCTION) ---
    const handlePayment = async () => {
        try {
            if (!booking.apptPrice || !booking.apptNumber) return;

            localStorage.setItem('temp_appointment_data', JSON.stringify({
                date: booking.apptDate,
                number: booking.apptNumber
            }));

            const paymentPayload = {
                amount: booking.apptPrice,
                ccy: 980,
                merchantPaymInfo: {
                    reference: booking.apptNumber.toString(),
                    destination: booking.apptServiceName,
                    customerEmails: [booking.apptEmail],
                    basketOrder: [{
                        name: booking.apptServiceName,
                        qty: 1,
                        sum: booking.apptPrice,
                        code: booking.apptNumber.toString()
                    }]
                },
                redirectUrl: window.location.origin + window.location.pathname + '?payment_status=success',
                webHookUrl: "https://yourwebsite.com/mono-webhook"
            };

            // Звертаємось до нашого серверного файлу /api/create-invoice
            const { data } = await axios.post('/api/create-invoice', paymentPayload);

            if (data?.pageUrl) {
                window.location.href = data.pageUrl;
            } else {
                setError('Не вдалося отримати посилання на оплату');
            }
        } catch (err) {
            setError('Помилка оплати: ' + (err.response?.data?.details?.errCode || err.message));
        }
    };

    if (status.loadingResources) return <div style={{padding:'50px',textAlign:'center'}}>Завантаження...</div>;

    const renderInput = (name, placeholder, type = 'text', maxLength = 50) => (
        <div className="mc-input-group">
            <input
                name={name}
                type={type}
                placeholder={placeholder}
                value={form[name]}
                onChange={handleInputChange}
                className={`mc-input ${errors[name] ? 'input-error' : ''}`}
                maxLength={maxLength}
            />
            {errors[name] && <span className="mc-error-text">{errors[name]}</span>}
        </div>
    );

    return (
        <div className="mc-container">
            <h2 className="mc-title">Онлайн запис</h2>

            {!selection.doctorId && !booking.isCreated && (
                <div className="mc-resource-grid">
                    {resources.map(item => (
                        <div key={item.id} className="mc-resource-card" onClick={() => handleDoctorSelect(item.id)}>
                            <div className="mc-resource-image-wrapper">
                                {item.logo && <img src={item.logo} alt={item.last_name} />}
                            </div>
                            <h3 className="mc-card-name">{item.last_name} {item.name} {item.middle_name}</h3>
                            {item.description && <p className="mc-card-spec">{item.description}</p>}
                        </div>
                    ))}
                </div>
            )}

            {selection.doctorId && doctorDetails && !booking.isCreated && (
                <div className="mc-card-layout">
                    <aside className="mc-sidebar">
                        <div className="mc-doctor-info">
                            <div className="mc-doctor-photo">
                                <img src={doctorDetails.logo} alt="" />
                            </div>
                            <h3 className="mc-doctor-name">
                                {doctorDetails.last_name} {doctorDetails.name} {doctorDetails.middle_name}
                            </h3>
                            {/* Відображаємо опис лікаря під іменем */}
                            {doctorDetails.description && (
                                <p className="mc-card-spec" style={{ fontSize: '14px', color: '#666', marginBottom: '10px' }}>
                                    {doctorDetails.description}
                                </p>
                            )}
                            <button className="mc-link-change" onClick={() => handleDoctorSelect(null)}>
                                Змінити спеціаліста
                            </button>
                        </div>
                    </aside>

                    <main className="mc-content">
                        {status.loadingDetails ? (
                            <div style={{textAlign:'center'}}>Завантаження...</div>
                        ) : (
                            <>
                                {!slotsData && !status.loadingSlots && (
                                    <div className="mc-services-list">
                                        {services.map(srv => (
                                            <div key={srv.service_id} className="mc-service-row"
                                                 onClick={() => handleServiceSelect(srv.resourceId, srv.service_id, srv.prices[0].amount, srv.name)}>
                                                <span className="mc-service-name">{srv.name}</span>
                                                <span className="mc-service-price">{(srv.prices[0].amount / 100).toFixed(0)} ₴</span>
                                            </div>
                                        ))}
                                    </div>
                                )}

                                {status.loadingSlots && <div style={{textAlign:'center'}}>Пошук часу...</div>}

                                {slotsData && !status.loadingSlots && (
                                    <>
                                        <div className="mc-selected-service">
                                            <span className="mc-selected-title">{selection.serviceName}</span>
                                            <button className="mc-link-change-small" onClick={() => setSlotsData(null)}>Змінити</button>
                                        </div>

                                        <div className="mc-section">
                                            <h4 className="mc-label">Доступні дати:</h4>
                                            <div className="mc-dates-row">
                                                {availableDates.map(ds => (
                                                    <button key={ds.date}
                                                            className={`mc-date-card ${ds.isDisabled ? 'disabled' : ''} ${selection.dateSlot?.date === ds.date ? 'active' : ''}`}
                                                            onClick={() => !ds.isDisabled && setSelection(prev => ({...prev, dateSlot: ds, timeSlot: null}))}>
                                                        <span className="mc-date-weekday">{ds.dayName}</span>
                                                        <span className="mc-date-number">{ds.dayNum} {ds.monthName}</span>
                                                    </button>
                                                ))}
                                            </div>
                                        </div>

                                        {selection.dateSlot && (
                                            <div className="mc-section">
                                                <h4 className="mc-label">Час:</h4>
                                                {selection.dateSlot.slots.length > 0 ? (
                                                    <div className="mc-time-row">
                                                        {selection.dateSlot.slots.map(slot => (
                                                            <button key={slot.time.start_time}
                                                                    className={`mc-time-pill ${selection.timeSlot === slot.time ? 'active' : ''}`}
                                                                    onClick={() => setSelection(prev => ({...prev, timeSlot: slot.time}))}>
                                                                {secondsToHours(slot.time.start_time).displayTime}
                                                            </button>
                                                        ))}
                                                    </div>
                                                ) : <div className="mc-no-slots-message">На цю дату немає доступного часу</div>}
                                            </div>
                                        )}

                                        {selection.timeSlot && (
                                            <>
                                                <div className="mc-form-wrapper">
                                                    <div className="mc-inputs-grid">
                                                        {renderInput('name', "Ім'я")}
                                                        {renderInput('lastName', "Прізвище")}
                                                        {renderInput('phone', "Наприклад +380...", 'tel', 13)}
                                                        {renderInput('email', "Email", 'email')}
                                                    </div>
                                                </div>

                                                <div className="mc-footer-outside">
                                                    <div className="mc-footer-inner">
                                                        {!booking.otpSent ? (
                                                            <button className="mc-btn-primary" onClick={handleCreateAppointment}>Записатися на прийом</button>
                                                        ) : (
                                                            <div className="mc-otp-area">
                                                                <div className="otp-input-wrapper">
                                                                    <span className="otp-label">Код з SMS:</span>
                                                                    <input className="mc-input-otp" maxLength="5" value={booking.verificationCode}
                                                                           onChange={e => setBooking(prev => ({...prev, verificationCode: e.target.value}))} />
                                                                </div>
                                                                <button className="mc-btn-primary" onClick={handleCreateAppointment}>
                                                                    Записатися до лікаря
                                                                </button>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                    </>
                                )}
                            </>
                        )}
                    </main>
                </div>
            )}

            {booking.isCreated && (
                <div className="mc-result-wrapper">
                    {!booking.isPaid ? (
                        <div className="mc-result-box">
                            <h2>Запис створено!</h2>
                            <p className="mc-result-info">{booking.apptDate}</p>
                            <p className="mc-result-number">№ {booking.apptNumber}</p>
                            <button className="mc-btn-primary" onClick={handlePayment}>Оплатити замовлення</button>
                        </div>
                    ) : (
                        <div className="mc-result-box mc-success-box">
                            <div className="mc-success-icon">✓</div>
                            <h2>Оплата успішна!</h2>
                            <div className="mc-divider"></div>
                            <h3>Ви записані!</h3>
                            <p className="mc-result-info"><strong>Час:</strong> {booking.apptDate}</p>
                            <button className="mc-btn-outline" onClick={() => window.location.href = '/'}>На головну</button>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}